
var $ = jQuery = require('../../../node_modules/jquery/dist/jquery.min.js');
var _ = lodash = require('../../../node_modules/lodash/lodash.min.js');
var bootstrap = require('../../../node_modules/bootstrap/dist/js/bootstrap.js');

//var bootstrap_glyphicons = require('../../../node_modules/bootstrap/dist/fonts/glyphicons-halflings-regular.woff');
//var bootstrap_glyphicons = require('../../../node_modules/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf');

$(document).ready( function() {

  console.log("Ready app-0");
});




//////////////////
// WEBPACK FOOTER
// ./lib/sitefile/client/app-0.js
// module id = 0
// module chunks = 0